<template>
  <a-layout class="my-application-box">
    <a-card class="create-application" :bordered=false :class="fromLocation==='msg'?'msg-create-application':''">
      <div slot="title" v-if="pageLayout.pageTitle">
        <a-icon v-if="fromLocation==='app'" style="cursor:pointer;" type="left-circle" @click="back" />
        <div>{{pageLayout.pageTitle}}</div>
        <span class="page-status " :class="{'page-status-yellow':params.status==='审批中','page-status-green':params.status==='审批通过'||params.status==='付款成功','page-status-red':params.status==='审批拒绝'||params.status==='付款失败','page-status-gray':params.status==='已撤回'}">{{params.status}}</span>
      </div>
      <div slot="extra" style="cursor:pointer" class="extra" v-if="pageLayout.functions">
        <span v-for="(item,index) in pageLayout.functions" :key="index" style="margin-left:17px;">
          <span class="extra-trigger" @click="retreatModalVisible=true" v-if="item.action==='withdraw'">
            <a-icon style="cursor:pointer" slot="suffixIcon" :component="'SvgIcEnter'" />撤回
          </span>
          <span class="extra-trigger" @click="modify" v-if="item.action==='modify_form'">
            <a-icon style="cursor:pointer" slot="suffixIcon" :component="'SvgIcEdit'" />修改
          </span>
        </span>
      </div>
      <div v-for="(layout,index) in pageLayout.contents" :key="index" v-if="loadedLayout && loadedInfo">
        <common-form :ref="'commonForm'" :layout="layout" v-if="layout.type==='commonForm'" :params="layout.field && params[layout.field]?params[layout.field]:{}" :can-edit="canEdit"></common-form>
        <multi-form :ref="'multiForm'" :layout="layout" v-if="layout.type==='multiForm'" :params="layout.field && params[layout.field]?params[layout.field]:[]" :can-edit="canEdit"></multi-form>
        <summation :layout="layout" v-if="layout.type==='summation'" :params="params[layout.field]?params[layout.field]:{}" :all-params="params" :from-detail="true"></summation>
        <upload v-if="layout.type==='upload'" :layout="layout" :params="params[layout.field]?params[layout.field]:[]" :can-edit="canEdit"></upload>
        <a-divider/>
      </div>
      <approval-flow :params="approvalFlowInfo" :init-text="'审批流数据加载中...'" v-if="loadedLayout && loadedInfo"></approval-flow>
      <div style="text-align:center" v-else>
        <a-spin tip="数据加载中..."></a-spin>
      </div>
      <a-row style="margin:30px 0 24px;" v-if="loadedInfo && loadedLayout">
        <a-col :xs="24" :sm="4"></a-col>
        <a-col :xs="24" :sm="10">
          <!-- <a-button @click="visibleComment = true" style="width:120px;">评论</a-button> -->
        </a-col>
      </a-row>
    </a-card>
    <a-modal :visible="retreatModalVisible" title="撤回" @ok="retreat" @cancel="retreatModalVisible=false" :confirm-loading="retreatLoading">
      <h4>你确定撤回采购申请吗？</h4>
    </a-modal>
    <comment-and-copy :visible="visibleComment" @cancel="visibleComment = false" @reload="reload"></comment-and-copy>
  </a-layout>
</template>

<script>
import UUID from "uuidjs";
import SvgIcBackbtn from "../../assets/svg/ic-left-circle-o.svg";
import SvgIcFile from "../../assets/svg/ic-file-o.svg";
import SvgIcEdit from "../../assets/svg/ic-edit-o.svg";
import SvgIcCopy from "../../assets/svg/ic-copy-o.svg";
import SvgIcEnter from "../../assets/svg/ic-enter.svg";
import CommonForm from "../../components/CommonForm.vue";
import MultiForm from "../../components/MultiForm.vue";
import Summation from "../../components/Summation.vue";
import ApprovalFlow from "../../components/ApprovalFlow.vue";
import FormModal from "../../components/FormModal.vue";
import Upload from "../../components/Upload.vue";
import { setTimeout } from "timers";
import LayoutConfig from "../../utils/LayoutConfig.js";
import { layoutConfig } from "../../utils/mockData.js";
import {
  gatherInfoForm,
  backInfoFormModal
} from "../../data/formModalConfigs.js";
import {
  getPurchaseLayout,
  getPurchaseDetailInfo,
  getPurchaseDetailFlow,
  retreatPurchase
} from "../../services/CommonService.js";
import { modifyPaymentInfo } from "../../services/MyApplicationListService.js";

export default {
  components: {
    SvgIcBackbtn,
    SvgIcFile,
    SvgIcEdit,
    SvgIcCopy,
    SvgIcEnter,
    CommonForm,
    MultiForm,
    Summation,
    ApprovalFlow,
    FormModal,
    Upload
  },
  data() {
    return {
      canEdit: false,
      retreatModalVisible: false,
      breadcrumb: [
        {
          label: "我的申请",
          path: ""
        }
      ],
      cardHeight: 0,
      applicationTitle: "发起采购申请",
      params: {
        init: true
      },
      loadedLayout: false,
      loadedInfo: false,
      pageLayout: {},
      approvalFlowInfo: [],
      fromLocation: undefined,
      retreatLoading: false,
      visibleComment: false
    };
  },

  created() {
    this.fromLocation =
      window.location.href.indexOf("fromLocation=msg") === -1 ? "app" : "msg";
    this.id = this.$route.query.id;
    Promise.all([this.fetchDetailInfo()]).then(() => {
      this.fetchLayout();
    });
    this.fetchApprovalFlow();
  },
  mounted() {},

  computed: {},

  methods: {
    fetchLayout() {
      this.loadedLayout = false;
      getPurchaseLayout({
        type: "detail",
        id: this.$route.query.id,
        menu_type: 1,
        ding_msg_switch:
          window.location.href.indexOf("fromLocation=msg") !== -1 ? 1 : 0
      }).then(res => {
        if (res.status === "success") {
          this.pageLayout = res.data;
          this.loadedLayout = true;
        } else {
          this.$Message.error(res.message);
          this.loadedLayout = true;
        }
      });
    },
    fetchDetailInfo() {
      this.loadedInfo = false;
      return getPurchaseDetailInfo({
        id: this.$route.query.id,
        menu_type: 1
      }).then(res => {
        if (res.status === "success") {
          this.params = Object.assign({}, this.params, res.data);
          this.loadedInfo = true;
        } else {
          this.$Message.error(res.message);
          this.loadedInfo = true;
        }
      });
    },
    fetchApprovalFlow() {
      getPurchaseDetailFlow({ id: this.$route.query.id }).then(res => {
        if (res.status === "success") {
          res.data.forEach((item, index) => {
            this.$set(this.approvalFlowInfo, index, item);
          });
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    back() {
      this.$router.replace({
        name: "myApplicationList"
      });
    },
    retreat() {
      let params = {
        apply_id: this.$route.query.id
      };
      this.retreatLoading = true;
      retreatPurchase(params).then(res => {
        if (res.status === "success") {
          this.retreatModalVisible = false;
          this.$Message.success("撤回成功");
          this.back();
        } else {
          this.$Message.error(res.message);
        }
        this.retreatLoading = false;
      });
    },
    modify() {
      this.$router.replace({
        name: "myPurchaseDetailEdit",
        query: {
          id: this.$route.query.id
        }
      });
    },

    reload() {
      this.visibleComment = false;
      this.fetchApprovalFlow();
    }
  }
};
</script>

<style lang="less">
.my-application-box {
  padding: 16px;
}
</style>
